import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PostsActions } from './sagas/actions';

const PostsComponent = () => {
    const navigate = useNavigate()

    const posts = useSelector((state: any) => state.posts.posts)
    const dispatch = useDispatch()
    useEffect(() => {
        console.log('Dispatching')
        dispatch({ type: PostsActions.FETCH_POSTS })
    }, [dispatch])

    const handleClick = () => {
        navigate('/')
    }

    return (
        <>
            {
                posts.length > 0 &&
                posts.slice(0, 10).map((post: any, i: number) => {
                    return (
                        <div key={i} className="card border rounded-sm mb-3 p-2" onClick={handleClick}>
                            <b>Post#{(i + 1).toString()}</b> - {post.title}
                        </div>
                    )
                })
            }
            {posts.length === 0 && <div>Empty</div>}
        </>
    )
}

export default PostsComponent
